import React from 'react';
import styles from './SharedGroup.module.scss';
import GroupIdentifierIcon from '@components/GroupIdentifierIcon';
import { GroupMembershipCount, GroupTitle } from '@views/Group/Header';
import { SharedGroup } from '@models/SharedGroup';
import SharedResourceUtilityBar from '@components/Sharing/SharedResourceUtilityBar';

export default function SharedGroupHeader({
  group,
  logIn,
}: {
  group: SharedGroup;
  logIn: () => void;
}) {
  return (
    <SharedResourceUtilityBar
      className={styles.utilityBar}
      sharedResource={group}
      sharedResourceType="group"
      logIn={logIn}
      after={<div className={styles.headerLine} style={{ background: group.color }} />}
    >
      <div className={styles.header}>
        <GroupIdentifierIcon group={group} className={styles.color} />
        <GroupTitle group={group} />
        <GroupMembershipCount group={group} />
      </div>
    </SharedResourceUtilityBar>
  );
}
